import ApiAdmin from "@/services/apiAdmin.service";
import ApiGael from "@/services/apiGael.service";
import { STAGE } from "@/common/config";
import {
  USER_CREATE,
  USER_DESTROY,
  SELECT_GROUP,
  FETCH_ALL
} from "@/store/actions/actions.type";
import {
  SET,
  UNSET,
  SET_SELECTED_GROUP
} from "@/store/mutations/mutations.type";

const state = {
  user: {}
};

const getters = {
  user(state) {
    return state.user;
  },
  accessRole(state) {
    return (role, resource = null) => {
      return (
        state.user.hasResourceRole && state.user.hasResourceRole(role, resource)
      );
    };
  },
  hasAccessGroup(state) {
    return role => {
      return state.user.groups.includes(role);
    };
  }
};

const actions = {
  [USER_CREATE](context, keycloak) {
    return new Promise(resolve => {
      const user = {
        name: keycloak.idTokenParsed.name,
        email: keycloak.idTokenParsed.email,
        firstName: keycloak.idTokenParsed.given_name,
        lastName: keycloak.idTokenParsed.family_name,
        groups: keycloak.idTokenParsed.groups,
        planos: keycloak.idTokenParsed.planos,
        hasResourceRole: keycloak.hasResourceRole,
        selectedGroup: "",
        accountUrl: "//myaccount.eadstock.com.br",
        avatar: "",
        resourceAccessRoles:
          keycloak.resourceAccess[`${STAGE}eadstockwebapp`].roles,
        sessionId: keycloak.sessionId
      };

      context.commit(SET, user);
      context.dispatch(SELECT_GROUP, keycloak.idTokenParsed.groups);
      resolve();
    });
  },
  [USER_DESTROY](context) {
    context.commit(UNSET);
  },
  [SELECT_GROUP](context, groups) {
    //Buscando o primeiro grupo do array que seja do eadstock
    //No caso de ter um user que está em vários grupos do eadstock
    //ex.: /eadstock-b42 /eadstock-unimar etc... precisaremos implementar um dropdown no sistema para o usuário trocar o grupo
    const group = groups.find((item, index) => {
      return item.indexOf("/eadstock-") != -1 ? item : false;
    });
    context.commit(SET_SELECTED_GROUP, group);
  },

  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      ApiGael.query("dashboards/disciplinas/total")
        .then(response => {
          context.commit(SET_ALL, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response.data);
        });
    });
  }
};

const mutations = {
  [SET](state, user) {
    state.user = user;
  },
  [UNSET](state) {
    state.user = {};
  },
  [SET_SELECTED_GROUP](state, group) {
    state.user.selectedGroup = group;
    ApiGael.setSelectedGroupHeader(group);
    ApiAdmin.setSelectedGroupHeader(group);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
